import { dollarsToCents, formatCents } from "@homero/pricing";
import Button from "antd/es/button";
import React, { useMemo } from "react";
import { Task } from "src/types/tasks";
import styled from "styled-components";

interface TasksMobileNavbarProps {
  nextAction: () => void;
  nextText?: string;
  loading?: boolean;
  selectedTasks: Task[];
}

export default function TasksMobileNavbar({
  nextAction,
  nextText = "Next",
  loading = false,
  selectedTasks,
}: TasksMobileNavbarProps) {
  const subtotal = useMemo(() => {
    return selectedTasks.reduce(
      (sum, task) => sum + task.current_price_cents / 100,
      0
    );
  }, [selectedTasks]);

  return (
    <Footer>
      <FooterContent>
        <Price>
          <small>
            Total ({selectedTasks.length} task
            {selectedTasks.length !== 1 ? "s" : ""})
          </small>
          <br />
          <h2>{formatCents(dollarsToCents(Number(subtotal) || 0))}</h2>
        </Price>
        <NextButton
          disabled={loading || selectedTasks.length === 0}
          loading={loading}
          type="primary"
          onClick={nextAction}
        >
          {nextText}
        </NextButton>
      </FooterContent>
    </Footer>
  );
}

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #d3f7ff;
  padding: 0.5rem 1rem;
  z-index: 1;
  box-shadow: 0px -1px 5px 0px rgba(0, 0, 0, 0.2);
`;

const NextButton = styled(Button)`
  background-color: var(--blue-200);
  color: #fff;
  height: auto;
  min-height: 44px;
  padding: 0.5rem 1.5rem;
  border: none;
  text-align: center;
  border-radius: 5px;
  font-size: 1rem;
  width: auto;

  &:disabled {
    background-color: #ccc;
  }

  .ant-btn-loading {
    padding-left: 1rem;
  }
`;

const Price = styled.div`
  h2 {
    font-weight: 600;
    line-height: 1;
    color: var(--blue-300);
    margin: 0;
  }

  small {
    color: #666;
  }

  text-align: left;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;
